/**
 * /pages/personaliza — premium mockup experience + Shopify cart
 * Depends on: st-personaliza-mockup.js, st-personaliza-motion.js
 */
(function () {
  'use strict';

  const root = document.querySelector('[data-personaliza]');
  if (!root) return;

  const fulfillmentMode = root.getAttribute('data-fulfillment-mode') || 'printful_api';
  const bridgeUrl = (root.getAttribute('data-printful-bridge') || '').replace(/\/$/, '');
  const isPrintfulApi = fulfillmentMode === 'printful_api' && Boolean(bridgeUrl);
  const assetBase = root.getAttribute('data-asset-base') || '';
  const mockupConfigUrl = root.getAttribute('data-mockup-config-url') || '';
  const cacheBust = root.getAttribute('data-pz-build') || 'real-v7';

  const photoManifest = (() => {
    try {
      return JSON.parse(root.querySelector('[data-pz-mockup-photos]')?.textContent || '{}');
    } catch (_) {
      return { products: {}, thumbs: {} };
    }
  })();

  const catalog = (() => {
    try {
      return JSON.parse(root.querySelector('[data-pz-catalog]')?.textContent || '[]');
    } catch (_) {
      return [];
    }
  })();
  if (!catalog.length) return;

  const MAX_MB = 10;
  const MAX_BYTES = MAX_MB * 1024 * 1024;
  const ALLOWED = ['image/png', 'image/jpeg', 'image/webp'];
  const STORAGE = 'st-pz-design-v1';

  const BRAND_FILTERS = {
    Apple: [/iphone/i],
    Samsung: [/galaxy|samsung/i],
    Xiaomi: [/xiaomi|redmi|poco/i],
    Google: [/pixel/i],
    Otro: [/otro|personalizado|custom/i],
  };

  const COLORS = {
    blanco: '#f5f5f5',
    negro: '#111111',
    gris: '#9ca3af',
    'azul marino': '#1e3a5f',
    navy: '#1e3a5f',
    natural: '#d6c6a8',
    transparente: '#e8eef5',
    black: '#111',
    white: '#f5f5f5',
  };

  const els = {
    canvas: root.querySelector('[data-pz-canvas]'),
    mockupImg: root.querySelector('[data-pz-mockup-img]'),
    stage: root.querySelector('[data-pz-stage]'),
    thumbs: root.querySelector('[data-pz-thumbs]'),
    products: root.querySelector('[data-pz-products]'),
    drop: root.querySelector('[data-pz-drop]'),
    upload: root.querySelector('[data-pz-upload]'),
    mockupHost: root.querySelector('[data-pz-mockup-host]'),
    file: root.querySelector('[data-pz-file-input]'),
    fileCard: root.querySelector('[data-pz-file-card]'),
    fileThumb: root.querySelector('[data-pz-file-thumb]'),
    fileName: root.querySelector('[data-pz-file-name]'),
    fileSize: root.querySelector('[data-pz-file-size]'),
    replace: root.querySelector('[data-pz-replace]'),
    remove: root.querySelector('[data-pz-remove]'),
    error: root.querySelector('[data-pz-error]'),
    status: root.querySelector('[data-pz-status]'),
    controls: root.querySelector('[data-pz-controls]'),
    options: root.querySelector('[data-pz-options]'),
    customHost: root.querySelector('[data-pz-custom-model]'),
    modelBanner: root.querySelector('[data-pz-model-banner]'),
    qty: root.querySelector('[data-pz-qty]'),
    subtotal: root.querySelector('[data-pz-subtotal]'),
    shipping: root.querySelector('[data-pz-shipping]'),
    total: root.querySelector('[data-pz-total]'),
    sticky: root.querySelector('[data-pz-sticky]'),
    stickyPrice: root.querySelector('[data-pz-sticky-price]'),
    stickyAdd: root.querySelector('[data-pz-sticky-add]'),
    add: root.querySelector('[data-pz-add]'),
    buy: root.querySelector('[data-pz-buy]'),
    title: root.querySelector('[data-pz-product-title]'),
    floatCard: root.querySelector('[data-pz-float-card]'),
    floatImg: root.querySelector('[data-pz-float-img]'),
    success: root.querySelector('[data-pz-success]'),
    quality: root.querySelector('[data-pz-quality]'),
    rotateHint: root.querySelector('[data-pz-rotate-hint]'),
  };

  if (!els.canvas || !els.mockupImg || !window.STPersonalizaMockup || !window.STPersonalizaMotion) {
    console.warn('[personaliza] mockup/motion engines missing');
    return;
  }

  const state = {
    productKey: catalog[0].key,
    view: '000',
    design: null,
    designMeta: null,
    transform: { x: 0, y: 0, scale: 1 },
    drag: null,
    rotateDrag: null,
    userPausedSpin: false,
    selected: {},
    brandFilter: 'Apple',
    customBrand: '',
    customModel: '',
    pfFileId: null,
    applying: false,
  };

  let mockup = null;
  let motion = null;
  let mockupConfig = { products: {} };
  const productIcons = {};

  const isPlaceholderUrl = window.STPersonalizaMockup.isPlaceholderUrl || ((src) => !src);

  function product() {
    return catalog.find((p) => p.key === state.productKey) || catalog[0];
  }

  function money(cents) {
    return `${(Number(cents) / 100).toFixed(2).replace('.', ',')} €`;
  }

  function bytes(n) {
    if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
    return `${(n / (1024 * 1024)).toFixed(2)} MB`;
  }

  function loadImg(src, cors) {
    return window.STPersonalizaMockup.loadImg(src, cors);
  }

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function colorOf(label) {
    return COLORS[String(label).toLowerCase().trim()] || '#6b7280';
  }

  function isColor(name) {
    return /color|colour/i.test(name || '');
  }

  function isModelOpt(name) {
    return /modelo|model/i.test(name || '');
  }

  function isCustomModel(val) {
    return /otro|personalizado|custom/i.test(val || '');
  }

  function selectedColorLabel() {
    const p = product();
    const colorOpt = p.options.find((o) => isColor(o.name));
    return colorOpt ? state.selected[colorOpt.name] : '';
  }

  function currentVariant() {
    const p = product();
    const opts = p.options.map((o) => state.selected[o.name]);
    return (
      p.variants.find((v) => {
        const vals = [v.option1, v.option2, v.option3].filter(Boolean);
        return opts.every((val, i) => vals[i] === val);
      }) ||
      p.variants.find((v) => v.available) ||
      p.variants[0]
    );
  }

  function viewsForProduct() {
    const cfg = mockupConfig.products?.[state.productKey];
    return (cfg && cfg.views) || photoManifest.spinAngles || ['000', '045', '090', '135', '180', '225', '270', '315'];
  }

  function printViewsForProduct() {
    const cfg = mockupConfig.products?.[state.productKey];
    return (cfg && cfg.printViews) || ['000', '180'];
  }

  function stepView(direction) {
    const views = viewsForProduct();
    const idx = Math.max(0, views.indexOf(state.view));
    state.view = views[(idx + direction + views.length) % views.length];
    renderThumbs();
    return syncMockup({ silent: true });
  }

  function snapToPrintView() {
    const prints = printViewsForProduct();
    if (prints.includes(state.view)) return Promise.resolve();
    const preferred = prints[0] || '000';
    state.view = preferred;
    renderThumbs();
    return syncMockup();
  }

  function shouldAutoSpin() {
    return !state.design && !state.userPausedSpin && !state.drag && !state.rotateDrag && viewsForProduct().length > 1;
  }

  function restartIdleSpin() {
    if (!motion) return;
    motion.stopIdleSpin();
    if (!shouldAutoSpin() || motion.reduced()) return;
    motion.startIdleSpin(() => {
      if (!shouldAutoSpin()) return;
      stepView(1);
    }, 780);
  }

  function setStatus(msg, ok) {
    if (!els.status) return;
    els.status.hidden = !msg;
    els.status.textContent = msg || '';
    els.status.classList.toggle('st-pz__status--ok', !!ok);
  }

  function showError(msg) {
    if (!els.error) return;
    els.error.hidden = !msg;
    els.error.textContent = msg || '';
  }

  function setUploadUI(hasFile) {
    if (els.upload) els.upload.classList.toggle('is-has-file', hasFile);
    if (els.drop) els.drop.hidden = hasFile;
    if (els.fileCard) els.fileCard.hidden = !hasFile;
  }

  function updateQuality() {
    if (!els.quality || !mockup) return;
    const q = mockup.getQualityLabel();
    if (!q) {
      els.quality.hidden = true;
      els.quality.textContent = '';
      els.quality.className = 'st-pz__quality';
      return;
    }
    els.quality.hidden = false;
    els.quality.textContent = q.label;
    els.quality.className = `st-pz__quality st-pz__quality--${q.key}`;
  }

  async function syncMockup(opts) {
    opts = opts || {};
    const p = product();
    const raw = (p.images && p.images[0]) || p.featured || null;
    const fallback = raw && !isPlaceholderUrl(raw) ? raw : null;
    await mockup.setProduct(state.productKey, {
      color: selectedColorLabel(),
      view: state.view,
      model: selectedModelLabel(),
      fallbackSrc: fallback,
    });
    if (state.design) {
      mockup.setDesign(state.design, state.transform);
    } else {
      mockup.setDesign(null);
    }
    if (!opts.silent) mockup.scheduleRender();
    updateRotateHint();
  }

  function updateRotateHint() {
    if (!els.rotateHint) return;
    els.rotateHint.hidden = viewsForProduct().length < 2;
  }

  function renderThumbs() {
    const views = viewsForProduct();
    if (!els.thumbs) return;
    if (views.length < 2) {
      els.thumbs.hidden = true;
      els.thumbs.innerHTML = '';
      return;
    }
    els.thumbs.hidden = false;
    const prints = printViewsForProduct();
    const printButtons = prints
      .map((v) => {
        const label = v === '180' || v === 'back' ? 'Espalda' : 'Frente';
        return `<button type="button" class="st-pz__thumb${state.view === v ? ' is-active' : ''}" data-pz-view="${v}">${label}</button>`;
      })
      .join('');
    const dots = views
      .map(
        (v, i) =>
          `<button type="button" class="st-pz__spin-dot${state.view === v ? ' is-active' : ''}" data-pz-view="${v}" aria-label="Ángulo ${i * 45}°"></button>`
      )
      .join('');
    els.thumbs.innerHTML = `
      <div class="st-pz__spin-bar" role="toolbar" aria-label="Vista 360">
        <div class="st-pz__spin-snaps">${printButtons}</div>
        <div class="st-pz__spin-track" data-pz-spin-track>${dots}</div>
        <p class="st-pz__spin-label">Arrastra - 360&deg;</p>
      </div>`;
    els.thumbs.querySelectorAll('[data-pz-view]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.dataset.pzView === state.view) return;
        state.userPausedSpin = true;
        motion.stopIdleSpin();
        state.view = btn.dataset.pzView;
        renderThumbs();
        await motion.frameCrossfade(els.stage, () => syncMockup());
      });
    });
  }

  function buildProductIcons() {
    catalog.forEach((p) => {
      productIcons[p.key] = p.thumbUrl || mockup.getThumbUrl(p.key) || null;
    });
  }

  function renderProducts() {
    els.products.innerHTML = catalog
      .map((p) => {
        const selected = p.key === state.productKey ? ' is-selected' : '';
        const icon = productIcons[p.key];
        const img = icon
          ? `<img src="${icon}" alt="" width="96" height="96" loading="lazy" class="st-pz__product-icon">`
          : `<span class="st-pz__emoji" aria-hidden="true">${p.emoji || '✦'}</span>`;
        return `<button type="button" class="st-pz__product${selected}" data-pz-pick="${esc(p.key)}" aria-pressed="${p.key === state.productKey}">
        ${img}
        <strong>${esc(p.shortName || p.title)}</strong>
        <em>${esc(p.priceLabel)}</em>
      </button>`;
      })
      .join('');

    els.products.querySelectorAll('[data-pz-pick]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        if (btn.dataset.pzPick === state.productKey) return;
        state.productKey = btn.dataset.pzPick;
        state.view = viewsForProduct()[0];
        state.brandFilter = state.productKey === 'funda' ? 'Apple' : state.brandFilter;
        seedOptions();
        renderProducts();
        renderThumbs();
        if (els.title) els.title.textContent = product().title;

        const hadDesign = !!state.design;
        let statusTimer = null;
        if (hadDesign) {
          statusTimer = setTimeout(() => setStatus('Aplicando tu diseño…', false), 200);
        }

        await motion.productTransition(els.stage, async () => {
          await motion.panelSwap(els.options, () => {
            renderOptions();
            updatePrice();
          });
          if (state.design) {
            state.transform = mockup.fitDesignToPrintArea();
          }
          await syncMockup();
          updateRotateHint();
        });

        clearTimeout(statusTimer);
        if (hadDesign) {
          setStatus('Vista previa lista — así se verá tu producto', true);
          updateQuality();
        } else {
          setStatus('', false);
          state.userPausedSpin = false;
          restartIdleSpin();
        }
      });
    });
  }

  function seedOptions() {
    state.selected = {};
    product().options.forEach((o) => {
      let values = o.values;
      if (state.productKey === 'funda' && isModelOpt(o.name)) {
        const filtered = filterModels(values);
        state.selected[o.name] = filtered[0] || values[0];
      } else if (isColor(o.name)) {
        state.selected[o.name] =
          values.find((v) => /blanco|white|natural|transparente/i.test(v)) || values[0];
      } else {
        state.selected[o.name] = values[0];
      }
    });
  }

  function filterModels(values) {
    const reList = BRAND_FILTERS[state.brandFilter];
    if (!reList) return values;
    return values.filter((v) => reList.some((re) => re.test(v)));
  }

  function renderOptions() {
    const p = product();
    let html = '';

    if (state.productKey === 'funda') {
      html += `<div><p class="st-pz__opt-name">Marca</p><div class="st-pz__pills" role="group" aria-label="Marca">`;
      Object.keys(BRAND_FILTERS).forEach((brand) => {
        const active = brand === state.brandFilter ? ' is-active' : '';
        html += `<button type="button" class="st-pz__pill${active}" data-pz-brand="${esc(brand)}" aria-pressed="${brand === state.brandFilter}">${esc(brand)}</button>`;
      });
      html += `</div></div>`;
    }

    html += p.options
      .map((o) => {
        let values = o.values.slice();
        if (state.productKey === 'funda' && isModelOpt(o.name)) {
          values = filterModels(values);
          if (!values.includes(state.selected[o.name])) state.selected[o.name] = values[0] || o.values[0];
        }
        const selected = state.selected[o.name];
        let ui;
        if (isColor(o.name)) {
          ui = `<div class="st-pz__swatches" role="group" aria-label="${esc(o.name)}">${values
            .map((v) => {
              const active = v === selected ? ' is-active' : '';
              const bg = /transparente/i.test(v) ? 'linear-gradient(135deg,#fff 40%,#cbd5e1 40%)' : colorOf(v);
              return `<button type="button" class="st-pz__swatch${active}" style="background:${bg}" data-opt="${esc(o.name)}" data-val="${esc(v)}" aria-label="${esc(v)}" aria-pressed="${v === selected}"></button>`;
            })
            .join('')}</div>`;
        } else {
          ui = `<div class="st-pz__pills st-pz__pills--wrap" role="group" aria-label="${esc(o.name)}">${values
            .map((v) => {
              const active = v === selected ? ' is-active' : '';
              return `<button type="button" class="st-pz__pill${active}" data-opt="${esc(o.name)}" data-val="${esc(v)}" aria-pressed="${v === selected}">${esc(v)}</button>`;
            })
            .join('')}</div>`;
        }
        const label = isModelOpt(o.name) ? 'Elige tu modelo' : o.name;
        return `<div><p class="st-pz__opt-name">${esc(label)}</p>${ui}</div>`;
      })
      .join('');

    els.options.innerHTML = html;

    els.options.querySelectorAll('[data-pz-brand]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        state.brandFilter = btn.dataset.pzBrand;
        const modelOpt = product().options.find((o) => isModelOpt(o.name));
        if (modelOpt) {
          const filtered = filterModels(modelOpt.values);
          state.selected[modelOpt.name] =
            filtered[0] || modelOpt.values.find((v) => isCustomModel(v)) || modelOpt.values[0];
        }
        renderOptions();
        updatePrice();
        await motion.colorCrossfade(els.stage, () => syncMockup());
      });
    });

    els.options.querySelectorAll('[data-opt]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const optName = btn.dataset.opt;
        const prev = state.selected[optName];
        state.selected[optName] = btn.dataset.val;
        renderOptions();
        updatePrice();
        updateModelBanner();

        const colorChange = isColor(optName);
        const modelChange = isModelOpt(optName);
        if (colorChange || modelChange) {
          // Size changes: no stage animation
          await motion.colorCrossfade(els.stage, () => syncMockup());
        } else if (prev !== btn.dataset.val) {
          // non-visual option (size) — keep preview stable
          mockup.scheduleRender();
        }
      });
    });

    renderCustomModelFields();
    updateModelBanner();
  }

  function renderCustomModelFields() {
    if (!els.customHost) return;
    const show =
      state.productKey === 'funda' &&
      (state.brandFilter === 'Otro' || isCustomModel(state.selected.Modelo || state.selected.Model || ''));
    if (!show) {
      els.customHost.hidden = true;
      els.customHost.innerHTML = '';
      return;
    }
    els.customHost.hidden = false;
    els.customHost.innerHTML = `
      <p class="st-pz__opt-name">Tu marca y modelo</p>
      <div class="st-pz__custom-grid">
        <label class="st-pz__field">
          <span>Marca</span>
          <input type="text" data-pz-custom-brand placeholder="Ej. Samsung, Oppo, Realme…" value="${esc(state.customBrand)}" maxlength="40" autocomplete="off">
        </label>
        <label class="st-pz__field">
          <span>Modelo</span>
          <input type="text" data-pz-custom-model-input placeholder="Ej. Galaxy A55, Reno 12…" value="${esc(state.customModel)}" maxlength="60" autocomplete="off">
        </label>
      </div>
      <p class="st-pz__hint" style="margin-top:0.45rem">Indica marca + modelo exactos para fabricar tu funda correctamente.</p>
    `;
    els.customHost.querySelector('[data-pz-custom-brand]')?.addEventListener('input', (e) => {
      state.customBrand = e.target.value;
      updateModelBanner();
    });
    els.customHost.querySelector('[data-pz-custom-model-input]')?.addEventListener('input', (e) => {
      state.customModel = e.target.value;
      updateModelBanner();
      syncMockup();
    });
  }

  function selectedModelLabel() {
    const modelOpt = product().options.find((o) => isModelOpt(o.name));
    const model = modelOpt ? state.selected[modelOpt.name] : '';
    if (isCustomModel(model) || state.brandFilter === 'Otro') {
      const brand = state.customBrand.trim();
      const mod = state.customModel.trim();
      if (brand && mod) return `${brand} ${mod}`;
      if (mod) return mod;
      if (brand) return brand;
      return 'Personalizado (completa marca y modelo)';
    }
    return model;
  }

  function updateModelBanner() {
    if (!els.modelBanner) return;
    if (state.productKey !== 'funda') {
      els.modelBanner.hidden = true;
      return;
    }
    const label = selectedModelLabel();
    if (!label) {
      els.modelBanner.hidden = true;
      return;
    }
    els.modelBanner.hidden = false;
    els.modelBanner.innerHTML = `<strong>Funda para ${esc(label)}</strong>`;
  }

  function updatePrice() {
    const v = currentVariant();
    if (!v) return;
    const qty = Math.max(1, Number(els.qty?.value || 1));
    const sub = v.price * qty;
    const prev = els.total?.textContent;
    if (els.subtotal) els.subtotal.textContent = money(sub);
    if (els.shipping) els.shipping.textContent = 'Al checkout';
    if (els.total) els.total.textContent = money(sub);
    if (els.stickyPrice) els.stickyPrice.textContent = money(sub);
    if (prev && prev !== money(sub)) {
      motion.priceFlash([els.subtotal, els.total, els.stickyPrice]);
    }
    const ok = !!v.available && !state.applying;
    [els.add, els.buy, els.stickyAdd].forEach((b) => {
      if (b) b.disabled = !ok;
    });
  }

  async function acceptFile(file) {
    showError('');
    if (!file) return;
    if (!ALLOWED.includes(file.type) && !/\.(png|jpe?g|webp)$/i.test(file.name)) {
      showError('Usa un archivo PNG, JPG o WEBP.');
      return;
    }
    if (file.size > MAX_BYTES) {
      showError(`El archivo supera el tamaño máximo (${MAX_MB} MB).`);
      return;
    }
    if (state.applying) return;
    state.applying = true;

    try {
      const url = URL.createObjectURL(file);
      const img = await loadImg(url, false);
      state.designMeta = { name: file.name, size: file.size, type: file.type, url };
      state.pfFileId = null;
      setUploadUI(true);
      if (els.fileThumb) els.fileThumb.src = url;
      if (els.fileName) els.fileName.textContent = file.name;
      if (els.fileSize) els.fileSize.textContent = bytes(file.size);
      if (els.controls) els.controls.hidden = false;

      setStatus('Aplicando tu diseño…', false);

      await motion.applyDesign({
        floatCard: els.floatCard,
        floatImg: els.floatImg,
        stageEl: els.stage,
        mockup,
        designImg: img,
        srcUrl: url,
        onSettled: () => {
          state.design = img;
          state.transform = { ...mockup.transform };
          motion.stopIdleSpin();
          state.userPausedSpin = true;
          snapToPrintView().then(() => {
            mockup.setDesign(state.design, state.transform);
            updateQuality();
            setStatus('Vista previa lista — así se verá tu producto', true);
          });
        },
      });

      try {
        const reader = new FileReader();
        reader.onload = () => {
          if (typeof reader.result === 'string' && reader.result.length < 1_500_000) {
            sessionStorage.setItem(
              STORAGE,
              JSON.stringify({
                name: file.name,
                size: file.size,
                type: file.type,
                dataUrl: reader.result,
                transform: state.transform,
              })
            );
          }
        };
        reader.readAsDataURL(file);
      } catch (_) {}
    } catch (_) {
      showError('No hemos podido cargar tu diseño. Inténtalo de nuevo.');
      setStatus('', false);
    } finally {
      state.applying = false;
      updatePrice();
    }
  }

  function clearDesign() {
    if (state.designMeta?.url?.startsWith('blob:')) {
      try {
        URL.revokeObjectURL(state.designMeta.url);
      } catch (_) {}
    }
    state.design = null;
    state.designMeta = null;
    state.pfFileId = null;
    state.transform = { x: 0, y: 0, scale: 1 };
    setUploadUI(false);
    if (els.controls) els.controls.hidden = true;
    if (els.file) els.file.value = '';
    showError('');
    setStatus('', false);
    updateQuality();
    sessionStorage.removeItem(STORAGE);
    mockup.setDesign(null);
    state.userPausedSpin = false;
    restartIdleSpin();
  }

  async function restoreDesign() {
    try {
      const raw = sessionStorage.getItem(STORAGE);
      if (!raw) return;
      const data = JSON.parse(raw);
      if (!data?.dataUrl) return;
      state.design = await loadImg(data.dataUrl, false);
      state.designMeta = { name: data.name, size: data.size, type: data.type, url: data.dataUrl };
      state.transform = data.transform || state.transform;
      setUploadUI(true);
      if (els.fileThumb) els.fileThumb.src = data.dataUrl;
      if (els.fileName) els.fileName.textContent = data.name;
      if (els.fileSize) els.fileSize.textContent = bytes(data.size || 0);
      if (els.controls) els.controls.hidden = false;
      mockup.setDesign(state.design, state.transform);
      updateQuality();
      setStatus('Vista previa lista — así se verá tu producto', true);
    } catch (_) {}
  }

  function bindUpload() {
    els.file?.addEventListener('change', (e) => acceptFile(e.target.files?.[0]));
    els.replace?.addEventListener('click', () => els.file?.click());
    els.remove?.addEventListener('click', clearDesign);
    ['dragenter', 'dragover'].forEach((ev) => {
      els.drop?.addEventListener(ev, (e) => {
        e.preventDefault();
        els.drop.classList.add('is-dragover');
      });
    });
    ['dragleave', 'drop'].forEach((ev) => {
      els.drop?.addEventListener(ev, (e) => {
        e.preventDefault();
        els.drop.classList.remove('is-dragover');
        if (ev === 'drop') acceptFile(e.dataTransfer.files?.[0]);
      });
    });
  }

  function bindControls() {
    els.controls?.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-pz-edit]');
      if (!btn || !state.design) return;
      const a = btn.dataset.pzEdit;
      if (a === 'in') state.transform.scale = Math.min(2.5, state.transform.scale + 0.1);
      if (a === 'out') state.transform.scale = Math.max(0.4, state.transform.scale - 0.1);
      if (a === 'reset') state.transform = mockup.fitDesignToPrintArea();
      mockup.setDesign(state.design, state.transform);
    });
  }

  function cycleView(direction) {
    const views = viewsForProduct();
    if (views.length < 2) return;
    const idx = views.indexOf(state.view);
    state.view = views[(idx + direction + views.length) % views.length];
    renderThumbs();
    return syncMockup();
  }

  function bindDrag() {
    const stage = els.stage;
    if (!stage) return;
    const threshold = 36;

    stage.addEventListener('pointerdown', (e) => {
      stage.setPointerCapture(e.pointerId);
      if (state.design && mockup.canPrintOnView(state.view)) {
        state.drag = { x: e.clientX, y: e.clientY, ox: state.transform.x, oy: state.transform.y };
        stage.classList.add('is-dragging');
      } else {
        motion.stopIdleSpin();
        state.rotateDrag = {
          x: e.clientX,
          startView: state.view,
          moved: false,
          lastIdx: viewsForProduct().indexOf(state.view),
        };
        stage.classList.add('is-rotating');
      }
    });

    stage.addEventListener('pointermove', (e) => {
      if (state.drag) {
        state.transform.x = state.drag.ox + (e.clientX - state.drag.x);
        state.transform.y = state.drag.oy + (e.clientY - state.drag.y);
        mockup.setDesign(state.design, state.transform);
        return;
      }
      if (!state.rotateDrag) return;
      const views = viewsForProduct();
      const dx = e.clientX - state.rotateDrag.x;
      if (Math.abs(dx) > 10) state.rotateDrag.moved = true;
      const startIdx = Math.max(0, views.indexOf(state.rotateDrag.startView));
      const steps = Math.round(-dx / threshold);
      const nextIdx = (startIdx + steps + views.length * 8) % views.length;
      if (nextIdx !== state.rotateDrag.lastIdx) {
        state.rotateDrag.lastIdx = nextIdx;
        state.view = views[nextIdx];
        renderThumbs();
        syncMockup({ silent: true });
      }
    });

    const end = async () => {
      if (state.rotateDrag?.moved) {
        state.userPausedSpin = true;
        renderThumbs();
      } else if (state.rotateDrag) {
        restartIdleSpin();
      }
      state.drag = null;
      state.rotateDrag = null;
      stage.classList.remove('is-dragging', 'is-rotating');
    };

    stage.addEventListener('pointerup', end);
    stage.addEventListener('pointercancel', end);
  }

  function bindIdleSpin() {
    restartIdleSpin();
  }

  function bindQty() {
    root.querySelector('[data-pz-qty-minus]')?.addEventListener('click', () => {
      els.qty.value = Math.max(1, Number(els.qty.value) - 1);
      updatePrice();
    });
    root.querySelector('[data-pz-qty-plus]')?.addEventListener('click', () => {
      els.qty.value = Number(els.qty.value) + 1;
      updatePrice();
    });
    els.qty?.addEventListener('change', updatePrice);
  }

  function validateBeforeCart() {
    if (!state.design) {
      showError('Sube tu diseño antes de continuar.');
      els.drop?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    if (state.productKey === 'funda') {
      const model = state.selected.Modelo || '';
      if (
        (isCustomModel(model) || state.brandFilter === 'Otro') &&
        (!state.customBrand.trim() || !state.customModel.trim())
      ) {
        showError('Escribe la marca y el modelo de tu móvil.');
        els.customHost?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return false;
      }
    }
    return true;
  }

  function designRef() {
    return `PZ-${Date.now().toString(36).toUpperCase()}`;
  }

  function buildOrderSummary(ref) {
    const p = product();
    const parts = [`Pedido personalizado Suleman Tech`, `Ref: ${ref}`, `Producto: ${p.title}`];
    Object.keys(state.selected).forEach((k) => {
      if (state.selected[k]) parts.push(`${k}: ${state.selected[k]}`);
    });
    if (state.productKey === 'funda') parts.push(`Modelo: ${selectedModelLabel()}`);
    parts.push(`Diseño: ${state.designMeta?.name || 'archivo'}`);
    parts.push('Te envío el archivo del diseño en este chat.');
    return parts.join('\n');
  }

  function compressDesignForHandoff() {
    return new Promise((resolve) => {
      if (!state.design) return resolve(null);
      try {
        const c = document.createElement('canvas');
        const max = 1200;
        const scale = Math.min(1, max / Math.max(state.design.naturalWidth, state.design.naturalHeight));
        c.width = Math.max(1, Math.round(state.design.naturalWidth * scale));
        c.height = Math.max(1, Math.round(state.design.naturalHeight * scale));
        c.getContext('2d').drawImage(state.design, 0, 0, c.width, c.height);
        resolve(c.toDataURL('image/jpeg', 0.85));
      } catch (_) {
        resolve(null);
      }
    });
  }

  function showHandoffModal(ref, checkout) {
    const modal = root.querySelector('[data-pz-handoff]') || document.querySelector('[data-pz-handoff]');
    if (!modal) {
      if (checkout) window.location.href = (window.ST_ROUTES && ST_ROUTES.checkout) || '/checkout';
      return;
    }
    const wa = root.dataset.whatsapp || '34936056583';
    const summary = buildOrderSummary(ref);
    const waUrl = `https://wa.me/${wa}?text=${encodeURIComponent(summary)}`;
    modal.hidden = false;
    modal.querySelector('[data-pz-handoff-ref]').textContent = ref;
    const waBtn = modal.querySelector('[data-pz-handoff-wa]');
    if (waBtn) waBtn.href = waUrl;
    const dl = modal.querySelector('[data-pz-handoff-download]');
    if (dl) {
      dl.onclick = async (e) => {
        e.preventDefault();
        const dataUrl = await compressDesignForHandoff();
        if (!dataUrl) return;
        const a = document.createElement('a');
        a.href = dataUrl;
        a.download = (state.designMeta?.name || 'diseno').replace(/\.[^.]+$/, '') + '-suleman.jpg';
        a.click();
      };
    }
    const goCheckout = modal.querySelector('[data-pz-handoff-checkout]');
    if (goCheckout) {
      goCheckout.onclick = () => {
        modal.hidden = true;
        window.location.href = (window.ST_ROUTES && ST_ROUTES.checkout) || '/checkout';
      };
      goCheckout.hidden = !checkout;
    }
    modal.querySelectorAll('[data-pz-handoff-close]').forEach((b) => {
      b.onclick = () => {
        modal.hidden = true;
        if (!checkout) document.querySelector('[data-cart-open]')?.click();
      };
    });
  }

  async function uploadDesignToPrintful() {
    if (!isPrintfulApi) return null;
    if (!bridgeUrl) throw new Error('Falta la URL del Worker Printful (configuración de la sección Personaliza).');
    if (!state.design) throw new Error('Sube un diseño primero');
    if (els.status) els.status.textContent = 'Subiendo diseño a Printful…';

    const blob = await new Promise((resolve, reject) => {
      const c = document.createElement('canvas');
      const max = 2400;
      let w = state.design.naturalWidth || state.design.width;
      let h = state.design.naturalHeight || state.design.height;
      const scale = Math.min(1, max / Math.max(w, h));
      c.width = Math.round(w * scale);
      c.height = Math.round(h * scale);
      c.getContext('2d').drawImage(state.design, 0, 0, c.width, c.height);
      c.toBlob((b) => (b ? resolve(b) : reject(new Error('No se pudo preparar el diseño'))), 'image/png');
    });

    const form = new FormData();
    form.append('file', blob, (state.designMeta?.name || 'diseno').replace(/\.[^.]+$/, '') + '.png');
    const res = await fetch(`${bridgeUrl}/upload-design`, { method: 'POST', body: form });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || !data.file_id) throw new Error(data.error || 'No se pudo subir el diseño a Printful');
    state.pfFileId = data.file_id;
    if (els.status) els.status.textContent = 'Diseño listo para Printful';
    return data.file_id;
  }

  async function addToCart(checkout) {
    showError('');
    if (!validateBeforeCart()) return;
    const v = currentVariant();
    if (!v) return;
    const qty = Math.max(1, Number(els.qty?.value || 1));
    const ref = designRef();

    const btn = checkout ? els.buy : els.add;
    const stickyBtn = !checkout ? els.stickyAdd : null;
    motion.setButtonState(btn, 'loading');
    if (stickyBtn) motion.setButtonState(stickyBtn, 'loading');
    if (btn) btn.disabled = true;

    try {
      let fileId = state.pfFileId;
      if (isPrintfulApi) fileId = await uploadDesignToPrintful();

      const properties = {
        Diseño: state.designMeta?.name || 'diseño',
        'Ref diseño': ref,
        Producto: product().title,
        _pf_slot: state.productKey,
        _pz_preview_ref: ref,
      };
      if (isPrintfulApi && fileId) {
        properties._pf_file_id = String(fileId);
        properties['PF file id'] = String(fileId);
        properties.Personalización = 'Printful auto';
      } else {
        properties.Personalización = 'Enviar archivo por WhatsApp tras el pedido';
        properties['Vista previa'] = 'Mockup generado automáticamente';
      }
      if (state.productKey === 'funda') {
        properties.Modelo = selectedModelLabel();
        if (state.customBrand.trim()) properties.Marca = state.customBrand.trim();
        if (state.customModel.trim()) properties['Modelo exacto'] = state.customModel.trim();
      }
      Object.keys(state.selected).forEach((k) => {
        if (isColor(k) || /talla|size|capacidad/i.test(k)) properties[k] = state.selected[k];
      });

      try {
        const preview = mockup.exportPreview(480);
        if (preview && preview.length < 900_000) {
          sessionStorage.setItem(`st-pz-preview-${ref}`, preview);
        }
      } catch (_) {}

      if (!isPrintfulApi) {
        try {
          const dataUrl = await compressDesignForHandoff();
          if (dataUrl) sessionStorage.setItem(`st-pz-file-${ref}`, dataUrl);
        } catch (_) {}
      }

      const cartAdd = (window.ST_ROUTES && ST_ROUTES.cart_add) || '/cart/add.js';
      const res = await fetch(cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: v.id, quantity: qty, properties }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'No se pudo añadir al carrito');
      }

      try {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            attributes: {
              'Pedido personalizado': isPrintfulApi ? 'Printful auto' : 'Sí — enviar diseño por WhatsApp',
              'Ref diseño': ref,
            },
          }),
        });
      } catch (_) {}

      document.dispatchEvent(new CustomEvent('cart:updated'));
      window.dispatchEvent(new Event('st:refresh-cart'));

      motion.setButtonState(btn, 'success');
      if (stickyBtn) motion.setButtonState(stickyBtn, 'success');

      await new Promise((r) => setTimeout(r, 220));

      if (isPrintfulApi) {
        if (checkout) {
          window.location.href = (window.ST_ROUTES && ST_ROUTES.checkout) || '/checkout';
        } else {
          document.querySelector('[data-cart-open]')?.click();
        }
      } else {
        showHandoffModal(ref, checkout);
      }
    } catch (err) {
      showError(err.message || 'Error al añadir al carrito');
      motion.setButtonState(btn, null);
      if (stickyBtn) motion.setButtonState(stickyBtn, null);
    } finally {
      setTimeout(() => {
        motion.setButtonState(btn, null);
        if (stickyBtn) motion.setButtonState(stickyBtn, null);
        updatePrice();
      }, 600);
    }
  }

  function bindCart() {
    els.add?.addEventListener('click', () => addToCart(false));
    els.buy?.addEventListener('click', () => addToCart(true));
    els.stickyAdd?.addEventListener('click', () => addToCart(false));
  }

  function bindSticky() {
    if (!els.sticky || !els.add) return;
    const onScroll = () => {
      const addRect = els.add.getBoundingClientRect();
      const mockupRect = els.mockupHost?.getBoundingClientRect();
      const pastMockup = mockupRect ? mockupRect.bottom < 80 : false;
      const addInView = addRect.top < window.innerHeight - 72 && addRect.bottom > 0;
      const show = pastMockup && !addInView;
      els.sticky.hidden = !show;
      document.body.classList.toggle('st-pz-sticky-visible', show);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function enhanceCartDrawerPreview() {
    // After cart refresh, swap line images when preview is in sessionStorage
    const apply = () => {
      document.querySelectorAll('[data-cart-drawer] .st-cart-drawer__item, [data-cart-drawer] li').forEach((row) => {
        const text = row.textContent || '';
        const m = text.match(/PZ-[A-Z0-9]+/i);
        if (!m) return;
        const preview = sessionStorage.getItem(`st-pz-preview-${m[0]}`);
        if (!preview) return;
        const img = row.querySelector('img');
        if (img && img.src !== preview) img.src = preview;
      });
    };
    document.addEventListener('cart:updated', () => setTimeout(apply, 120));
    window.addEventListener('st:refresh-cart', () => setTimeout(apply, 200));
  }

  async function loadConfig() {
    if (mockupConfigUrl) {
      try {
        const res = await fetch(mockupConfigUrl, { credentials: 'same-origin', cache: 'no-store' });
        if (res.ok) return await res.json();
      } catch (_) {}
    }
    const inline = root.querySelector('[data-pz-mockup-config]');
    if (inline?.textContent?.trim()) {
      try {
        return JSON.parse(inline.textContent);
      } catch (_) {}
    }
    return { products: {} };
  }

  (async function init() {
    mockupConfig = await loadConfig();
    motion = new window.STPersonalizaMotion.MotionController({
      success: els.success,
      quality: els.quality,
    });
    mockup = new window.STPersonalizaMockup.ProductMockup(els.canvas, els.mockupImg, mockupConfig, {
      photos: photoManifest,
    });

    if (state.productKey === 'funda') state.brandFilter = 'Apple';
    state.view = viewsForProduct()[0];
    seedOptions();
    buildProductIcons();
    renderProducts();
    renderThumbs();
    renderOptions();
    bindUpload();
    bindControls();
    bindDrag();
    bindIdleSpin();
    bindQty();
    bindCart();
    bindSticky();
    enhanceCartDrawerPreview();
    if (els.title) els.title.textContent = product().title;

    await syncMockup();
    updateRotateHint();
    mockup.prefetch();
    await restoreDesign();
    if (state.design) {
      motion.stopIdleSpin();
      await snapToPrintView();
    } else {
      restartIdleSpin();
    }
    updatePrice();
    window.addEventListener('resize', () => mockup.scheduleRender());
  })();
})();
